import React from 'react';
import { useTranslation } from 'react-i18next';

const SupportContent = () => {
  const { t , i18n} = useTranslation()

  return (
    <div className="content px-4">
    <p>Managed & Supported</p>
    <h3 className='uppercase'>{t("Support services")}</h3>
    <p className="mt-2">
  {t("Launching your website is only the beginning. With our dedicated support services, we make sure your platform continues to deliver results every single day. Whether it’s troubleshooting technical issues, updating content, or fine-tuning performance, our team is always ready to step in. We’re here to ensure your website doesn’t just work it thrives, evolves, and keeps supporting your business goals long after launch.")}

    </p>
  </div>
  );
}

export default SupportContent;
